import React, { useState, useLayoutEffect } from 'react';
import Cookies from 'js-cookie';
import {
    Box,
    Button,
    Flex,
    Heading,
    Link,
    Text,
} from '@chakra-ui/react';

const CONSENT_COOKIE_NAME = 'anvil_consent';

function ConsentModal({ configId }) {
    const [visible, setVisible] = useState(true);
    const [config] = useState(() => {
        const configEl = document.getElementById(configId);
        if (configEl) {
            try {
                return JSON.parse(configEl.textContent);
            } catch (e) {
                console.error('Failed to parse consent config:', e);
            }
        }
        return null;
    });

    useLayoutEffect(() => {
        if (visible && config) {
            const originalOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = originalOverflow;
            };
        }
    }, [visible, config]);

    const handleAccept = () => {
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        Cookies.set(CONSENT_COOKIE_NAME, '1', {
            expires: expires,
            path: '/',
            sameSite: 'None',
            secure: true,
        });
        setVisible(false);
        window.location.reload();
    };

    if (!visible || !config) {
        return null;
    }

    return (
        <Flex
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bg="blackAlpha.600"
            zIndex={9999}
            align="center"
            justify="center"
            p={{ base: 2, md: 4 }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="consent-title"
        >
            <Box
                bg="white"
                borderRadius="lg"
                maxW="480px"
                w="100%"
                maxH="90vh"
                overflow="auto"
                boxShadow="0 4px 24px rgba(0, 0, 0, 0.15)"
            >
                <Box p={{ base: 5, md: 6 }}>
                    <Heading
                        id="consent-title"
                        as="h2"
                        fontSize={{ base: 'xl', md: '2xl' }}
                        fontWeight="700"
                        textAlign="center"
                        mb={2}
                        color="#1a1a1a"
                    >
                        {config.site_name}
                    </Heading>

                    <Text
                        fontSize={{ base: 'md', md: 'lg' }}
                        fontWeight="600"
                        textAlign="center"
                        mb={3}
                        color="#1a1a1a"
                    >
                        Legal Terms and Privacy
                    </Text>

                    <Text
                        fontSize="sm"
                        lineHeight="1.6"
                        color="#4a4a4a"
                        textAlign="center"
                    >
                        By proceeding, you accept our{' '}
                        <Link href={config.terms_of_service_url} color="#0066cc" textDecoration="underline" isExternal>
                            Terms of Service
                        </Link>{' '}
                        (including arbitration and class action waiver) and{' '}
                        <Link href={config.privacy_policy_url} color="#0066cc" textDecoration="underline" isExternal>
                            Privacy Policy
                        </Link>
                        . We and our partners use cookies, pixels, and similar technologies
                        to collect information for purposes outlined in our{' '}
                        <Link href={config.privacy_policy_url} color="#0066cc" textDecoration="underline" isExternal>
                            Privacy Policy
                        </Link>
                        , including personalized content and ads.
                    </Text>

                    <Button
                        w="100%"
                        mt={5}
                        py={6}
                        bg="#1a73e8"
                        color="white"
                        fontSize="md"
                        fontWeight="600"
                        textTransform="uppercase"
                        letterSpacing="0.025em"
                        borderRadius="md"
                        _hover={{ bg: '#1557b0' }}
                        _active={{ bg: '#1557b0' }}
                        onClick={handleAccept}
                    >
                        Continue
                    </Button>
                </Box>
            </Box>
        </Flex>
    );
}

export default ConsentModal;
